import type { ISelectItem, IItemWithLocation } from '~/types/models'

const mn = '[cynqueModules/dataObjects/LocationCounts]'

/**
 * Items per location. `weightOf` as in countUniqueStatii: the msService
 * roll-ups pass `getCountableMSServiceQuantity`, so the counts add up to # Srvs.
 */
export function countUniqueLocations<T extends IItemWithLocation>(
  itemsWithLocation: T[],
  weightOf: (item: T) => number = () => 1
): {
  location: ISelectItem
  count: number
}[] {
  const fn = `${mn} countUniqueLocations |`
  console.debug(`${fn} counting ${itemsWithLocation.length} items`)
  const map = Map.groupBy(itemsWithLocation, (item) => item.location.id)
  const countsList = [...map.values()].map((items) => ({
    location: items[0].location,
    count: items.reduce((sum, item) => sum + weightOf(item), 0),
  }))
  return countsList.sort((a, b) =>
    a.location.label.localeCompare(b.location.label)
  )
}
